import { getSharepointDocumentDownloadDetails } from '../graphql/queries';
import api from './api';

export default async function getSharepointDownloadUrl(
  ContactID: string | undefined,
  FileID: string,
) {
  try {
    const { data } = await api.graphql({
      query: getSharepointDocumentDownloadDetails,
      variables: { ContactID, FileID },
    });

    return data?.getSharepointDocumentDownloadDetails?.Url || null;
  } catch {
    return null;
  }
}
